module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#photo",
      toString: function () {
        return this.url;
      }
    }